import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { classes } from './FileUpload.st.css';
import { classes as rootClasses } from '../../../file-upload/file-upload-wut.st.css';
import { FileList } from './components/FileList';
import { DATA_HOOKS } from './dataHooks';
import { useFocusWhen } from './components/use-focus-when';
export const FileUploadDetails = _ref => {
  let {
    fileInputRef,
    fileUploadButtonRef,
    textBelowButtonRef,
    files,
    onDeleteClick,
    hasError,
    explanationText
  } = _ref;
  const filesExist = files && Boolean(files.length);
  useFocusWhen(() => !filesExist, fileUploadButtonRef);
  if (filesExist) {
    return /*#__PURE__*/React.createElement("div", {
      className: rootClasses.root
    }, /*#__PURE__*/React.createElement(FileList, {
      files: files,
      explanationText: explanationText,
      fileInputRef: fileInputRef,
      textBelowButtonRef: textBelowButtonRef,
      onDeleteClick: onDeleteClick,
      hasError: hasError
    }));
  }
  if (explanationText) {
    return /*#__PURE__*/React.createElement("div", {
      className: rootClasses.root
    }, /*#__PURE__*/React.createElement(Text, {
      "data-hook": DATA_HOOKS.explanation,
      className: classes.explanation
    }, explanationText));
  }
  return null;
};
//# sourceMappingURL=FileUploadDetails.js.map